import classNames from 'classnames'
import Resource from 'components/Resource'
import style from 'components/ResourceList.module.scss'
import { motion } from 'framer-motion'
import { rootVariants } from 'lib/constants'
import React from 'react'
import { useInView } from 'react-intersection-observer'

const ResourceList = ({ resources }) => {
  const { ref, inView, entry } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  })

  const className = classNames(style.root, {})

  return (
    <motion.div
      className={className}
      variants={rootVariants}
      initial="initial"
      animate={inView ? 'animate' : 'initial'}
      exit="exit"
      ref={ref}
    >
      <div className={style.content}>
        <ul className={style.list}>
          {resources.map(resource => {
            return (
              <li key={resource.id} className={style.item}>
                <Resource
                  title={resource.title}
                  subTitle={resource.subTitle}
                  url={resource.url}
                  isVideo={resource.isVideo}
                  isRestricted={resource.isRestricted}
                  icon={resource.icon}
                  theme="light"
                />
              </li>
            )
          })}
        </ul>
      </div>
    </motion.div>
  )
}

export default ResourceList
